import { ReactNode, useState } from "react";
import FlagQuestionModal from "../../components/Modal/FlagQuestionModal";
import { Button as BootstrapButton } from "react-bootstrap";
import { IoIosCheckmarkCircle } from "react-icons/io";
import {
  BsArrowLeftCircleFill,
  BsArrowRightCircleFill,
  BsFlag,
  BsFlagFill,
  BsStar,
  BsStarFill,
} from "react-icons/bs";
import { FlaggedQuestion, Question } from "../../types";
import { isQuestionFlagged } from "../../utils/flagFeedback";

export const AssignmentPageTitle = (props: {
  questionNumber: number;
  question: Question;
  totalQuestions: number;
  isAssignmentMode: boolean;
  submitAssignment?: () => void;
  onNextQuestionClicked?: () => void;
  nextQuestionButtonDisabled?: boolean;
  onPreviousQuestionClicked?: () => void;
  prevQuestionButtonDisabled?: boolean;
  currentQuestionIndex?: number;
  handleStarQuestion?: () => void;
  onFlagged?: (flaggedQuestion: FlaggedQuestion) => void;
  leftExtra?: ReactNode;
  rightExtra?: ReactNode;
  isStarred?: boolean;
  isFlagged?: boolean;
  questionLabelPrefix?: string;
}) => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const isFlagged =
    props.isFlagged ?? isQuestionFlagged(props.question);

  return (
    <div className="assignment-page-title">
      <div className="assignment-page-title__left">
        <h4>
          {props.questionLabelPrefix ?? "Question"} {props.questionNumber} of {props.totalQuestions}
        </h4>

        {props.handleStarQuestion && (
          <button
            type="button"
            className="assignment-page-title__icon-btn"
            onClick={props.handleStarQuestion}
            aria-label={props.isStarred ? "Unstar question" : "Star question"}
          >
            {(props.isStarred ?? ((props.question.starredBy?.length ?? 0) > 0)) ? (
              <BsStarFill color="orange" aria-hidden="true" />
            ) : (
              <BsStar color="orange" aria-hidden="true" />
            )}
          </button>
        )}

        {isFlagged ? (
          <span
            className="assignment-page-title__icon-btn assignment-page-title__flag-btn"
            aria-label="Question flagged"
            title="This question has been flagged"
          >
            <BsFlagFill color="red" aria-hidden="true" />
          </span>
        ) : (
          <button
            type="button"
            className="assignment-page-title__icon-btn assignment-page-title__flag-btn"
            onClick={() => setShowModal(true)}
            aria-label="Flag question"
          >
            <BsFlag color="red" aria-hidden="true" />
          </button>
        )}
      </div>

      <div className="assignment-page-title__right">
        {props.rightExtra ? (
          <div className="assignment-page-title__extra">{props.rightExtra}</div>
        ) : null}
        {props.isAssignmentMode ? (
          <BootstrapButton
            variant="dark"
            size="sm"
            type="button"
            className="small"
            disabled={!props.submitAssignment}
            onClick={props.submitAssignment}
          >
            Submit Exam <IoIosCheckmarkCircle />
          </BootstrapButton>
        ) : undefined}

        {props.leftExtra ? (
          <div className="assignment-page-title__extra">{props.leftExtra}</div>
        ) : null}

        <button
          type="button"
          className="assignment-page-title__nav-btn"
          onClick={props.onPreviousQuestionClicked}
          disabled={props.prevQuestionButtonDisabled}
        >
          <BsArrowLeftCircleFill
            size={22}
            color={props.prevQuestionButtonDisabled ? "grey" : "var(--brand-accent)"}
            aria-hidden="true"
          />
        </button>

        <button
          type="button"
          className="assignment-page-title__nav-btn"
          onClick={props.onNextQuestionClicked}
          disabled={props.nextQuestionButtonDisabled}
        >
          <BsArrowRightCircleFill
            size={22}
            color={props.nextQuestionButtonDisabled ? "grey" : "var(--brand-accent)"}
            aria-hidden="true"
          />
        </button>
      </div>

      {!isFlagged ? (
        <FlagQuestionModal
          setShowModal={setShowModal}
          showModal={showModal}
          questionId={props.question.id}
          onFlagged={props.onFlagged}
        />
      ) : null}
    </div>
  );
};
